export default "__VITE_ASSET__vYp0d1gk__"